import { BasicLayout } from '../../components/BasicLayout';
import { LoginFormValues } from '../../../types/ui';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import LoginForm from './LoginForm';
import useAuth from '../../hooks/useAuth';
import useHandleExistingLoginNavigation from 'ui/hooks/useHandleExistingLogin';

const LoginScene = () => {
  const [searchParams] = useSearchParams({});

  const { login, isLoggedIn, loggingInStatus, loginError } = useAuth();
  const { handleLoginNavigation } = useHandleExistingLoginNavigation();
  const errorSearchParam = searchParams.get('errorMessage');

  useEffect(() => {
    if (!isLoggedIn) return;

    handleLoginNavigation();
  }, [isLoggedIn]);

  const loginSubmitted = (values: LoginFormValues) => {
    login(values.email, values.password);
  };

  return (
    <BasicLayout>
      <LoginForm
        onSubmit={loginSubmitted}
        isLoading={loggingInStatus === 'loading'}
        errorMessage={loginError || errorSearchParam}
      />
    </BasicLayout>
  );
};

export default LoginScene;
